import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs';
import { MARKETPLACE_FETCHER_ACTIONS } from '../actions/marketplaceActions';

export function fetchMarketplaceData(options) {
  let params = {
    "measurement-type" : options.measurementType,
    "count" : options.count,
    "locale": options.locale
  };
  if (options.templateName) {
    params.templateName = options.templateName;
  };
  return dispatch => {
    let url = API_PROTOCOL + BE_SERVER_ENDPOINT;
    if (options.isPublic) {
      url += '/v2.0/public/product-reco/pilot/' + options.pilotId;
    } else {
      url += '/v2.0/dashboard/users/' + options.userId + '/product-reco';
    }
    axios.get(url, {
        params : params
    }).then(
      (response) => {
        let data = [];
        for(let i =0;i < response.data.payload.length; i++){
          let recoMeta = response.data.payload[i].recommendationsMetaData;
          let insight = response.data.payload[i].insight;
          data[i]={
            appId: recoMeta.applianceTags[0],
            recoId : recoMeta.recommendationId,
            image : recoMeta.dashboardIcon,
            description : recoMeta.description,
            selfInstall : recoMeta.selfInstall,
            rebatesMetaData: recoMeta.rebatesMetaData,
            purchaseLinks : recoMeta.purchaseLinks,
            insight : insight,
            contractorLinks : recoMeta.contractorLinks[0],
            title : recoMeta.title,
            link : recoMeta.link,
            ctaText : recoMeta.callToAction
          }
        }
        dispatch({
          type: MARKETPLACE_FETCHER_ACTIONS.FETCH_DATA_SUCCESS,
          payload: {
            data: data
          }
        })
      },
      (error) =>{
        dispatch({
          type: MARKETPLACE_FETCHER_ACTIONS.FETCH_DATA_FAILURE,
          payload: {
            error: error
          }
        })
      }
    )
  }
}